<app-base-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  (submitted)="onSubmit()"
  title="project.card.copyDialog.header"
  testId="copy-project-dialog"
  width="34rem"
  submitLabel="project.card.copyDialog.submit"
  [submitDisabled]="submitDisabled"
>
  <div class="flex flex-col gap-4">
    <p-message severity="info" [text]="'project.card.copyDialog.info' | transloco"></p-message>

    <div class="flex flex-col gap-2">
      <label for="copy-project-name">{{ 'project.card.copyDialog.nameLabel' | transloco }}</label>
      <input
        id="copy-project-name"
        pInputText
        [ngModel]="name()"
        (ngModelChange)="name.set($event)"
        [attr.aria-invalid]="nameTaken()"
        data-testid="copy-project-name-input"
      />
      @if (nameTaken()) {
        <small class="text-red-500" data-testid="copy-project-name-error">
          {{ 'project.card.copyDialog.nameTaken' | transloco }}
        </small>
      }
    </div>
  </div>
</app-base-dialog>
